//Import
import React from "react";
import styled from "styled-components";
import styles from "./ModalCredito_styles";
import { Alert, Button, Table } from "antd";
//Components
import ModalContainer from "../ModalContainer";
import ModalCentered from "../ModalCentered";
import ModalHeader from "../ModalHeader";
import ModalContent from "../ModalContent";
import ModalFooter from "../ModalFooter";
import FormInput from "../FormInput/FormInput";
import FormInputReadOnly from "../FormInputReadOnly/FormInputReadOnly";
import FormSelect from "../FormSelect/FormSelect";
import ModalBottom from "../ModalBottom";
import ModalCronograma from "../ModalCronograma";

// External components
import { Tabs } from "antd";
import { formatNumber } from "../../helpers/formatNumber";
import ErrorInput from "../ErrorInput/ErrorInput";
import FormSelectCliente from "../FormSelectCliente/FormSelectCliente";
import FormTextArea from "../FormTextArea/FormTextArea";
import FormInputInteres from "../FormInputInteres/FormInputInteres";
import {formatDate} from "../../helpers/formatDate";

const callback = (key) => {};

/**
 *
 * Props:
 * type:String = Show modaltype 2 Options. "centered" "bottom"
 * show:Boolean = Modal Visibility
 * w:String = Modal width in css values
 * opacity:String / Number = Layout opacity values 0 to 1, 0.5 by default
 */

// Componente base
const ModalCredito_base = ({
                             formValues,
                             handleFormaPagoChange,
                             dataModal,
                             dataModalDetalle,
                             closeModal,
                             closeModalDetalle,
                             handleInputChange,
                             handleInputBlur,
                             errorsForm,
                             clientes,
                             productosExistentes,
                             formasPagos,
                             producto,
                             creditosEnrutados,
                             handleCrearSubmit,
                             handleClienteNuevo,
                             nombreClienteNuevo,
                             mostrarNombreClienteNuevo,
                             abrirModalCliente,
                             interesRuta,
                             handleCupoSelectCliente,
                             show,
                             type,
                             w,
                             opacity,
                             seguroRuta,
                             modificarSeguroRuta,
                             dataModalDetalleAbonos,
                             dataModalDetalleCuotas,
                             ...props
                           }) => {
  //Modal type centered
  const modalCentered = () => {
    return (
        <ModalContainer>
          <ModalCentered w={w}>
            <form onSubmit={handleCrearSubmit}>
              <ModalHeader closeModal={closeModal} icon="">
                {" "}
                Crear Crédito{" "}
              </ModalHeader>
              <ModalContent>
                {mostrarNombreClienteNuevo && (
                    <Alert
                        message={"Cliente: " + nombreClienteNuevo}
                        type="info"
                        showIcon
                        action={
                          <Button onClick={abrirModalCliente} size="small">
                            Ver
                          </Button>
                        }
                    />
                )}
                <FormSelectCliente
                    name="clienteId"
                    formlabel="Cliente"
                    clientes={clientes}
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                    handleClienteNuevo={handleClienteNuevo}
                    handleCupoSelectCliente={handleCupoSelectCliente}
                ></FormSelectCliente>
                {errorsForm.clienteId && (
                    <ErrorInput textoError={errorsForm.clienteId} />
                )}
                <FormInput
                    name="capital"
                    formlabel="Capital"
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                    type="number"
                    value={formValues.capital}
                ></FormInput>
                {errorsForm.capital && (
                    <ErrorInput textoError={errorsForm.capital} />
                )}
                {parseFloat(seguroRuta) > 0 && (
                    <>
                      <FormInputReadOnly
                          name="seguro"
                          formlabel={`Seguro (${seguroRuta}%)`}
                          handleInputChange={handleInputChange}
                          handleInputBlur={handleInputBlur}
                          type="number"
                          value={formValues.seguro}
                          readOnly={modificarSeguroRuta === 'true' ? false:true}
                      />
                      {errorsForm.seguro && (
                          <ErrorInput textoError={errorsForm.seguro} />
                      )}
                    </>
                )}
                <FormSelect
                    name="formaPagoId"
                    formlabel="Forma Pago"
                    formasPagos={formasPagos}
                    handleInputChange={handleFormaPagoChange} // Usamos la nueva función
                    handleInputBlur={handleInputBlur}
                ></FormSelect>
                {errorsForm.formaPagoId && <ErrorInput textoError={errorsForm.formaPagoId} />}
                <FormInputInteres
                    name="interes"
                    formlabel="Interés %"
                    value={formValues.interes} // Valor dinámico
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                    type="number"
                    readOnly={formValues.isInteresReadOnly} // Solo lectura si no es NULL en DB
                    placeholder={formValues.isInteresReadOnly ? "" : "Ingresa interés"}
                ></FormInputInteres>
                {errorsForm.interes && <ErrorInput textoError={errorsForm.interes} />}
                <FormInput
                    name="cuotas"
                    formlabel={`Cuotas (Máx: ${formValues.cantidadCuotas || 0})`}
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                    type="number"
                    value={formValues.cuotas}
                ></FormInput>
                {errorsForm.cuotas && <ErrorInput textoError={errorsForm.cuotas} />}
                <FormSelect
                    name="enrutarCredito"
                    formlabel="Enrutar después de"
                    creditosEnrutados={creditosEnrutados}
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                ></FormSelect>
                {errorsForm.enrutarCredito && (
                    <ErrorInput textoError={errorsForm.enrutarCredito} />
                )}
                <FormTextArea
                    name="producto"
                    formlabel="Producto"
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                    type="text"
                ></FormTextArea>
                {errorsForm.productosExistentes && (
                    <ErrorInput textoError={errorsForm.productosExistentes} />
                )}
                <FormTextArea
                    name="descripcion"
                    formlabel="Descripcion"
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                    type="text"
                ></FormTextArea>
                {errorsForm.descripcion && (
                    <ErrorInput textoError={errorsForm.descripcion} />
                )}
              </ModalContent>
              <ModalFooter closeModal={closeModal}></ModalFooter>
            </form>
          </ModalCentered>
        </ModalContainer>
    );
  };

  //Modal type bottom
  const modalBottom = () => {
    const colmuns = [
      {
        title: "Valor",
        dataIndex: "monto_total",
        render: (cuota) => formatNumber(cuota),
      },
      {
        title: "Saldo",
        dataIndex: "saldo_pendiente",
        render: (saldo) => formatNumber(saldo),
      },
        {
            title: "M. Pago",
            dataIndex: "metodo_pago",
        },
      {
        title: "Fecha",
        dataIndex: "created_at",
        render: (fecha) => formatDate(fecha),
      }
    ];

      // El cronograma se muestra únicamente si dataModalDetalleCuotas trae
      // información (no depende de la forma de pago del crédito).
      const mostrarCronograma =
        dataModalDetalleCuotas !== "" &&
        Array.isArray(dataModalDetalleCuotas?.cuotas) &&
        dataModalDetalleCuotas.cuotas.length > 0;

      const items = [
          {
              key: "1",
              label: "Pago",
              children:
                  dataModalDetalle !== "" ? (
                      <Table
                          columns={colmuns}
                          dataSource={dataModalDetalleAbonos.abonos || []}
                          pagination={false}
                          rowKey="id"
                      />
                  ) : null,
          },
          {
              key: "2",
              label: "Info General",
              children:
                  dataModalDetalle !== "" ? (
                      <>
                          <p>
                              <strong>Fecha Creación:</strong>{" "}
                              {formatDate(dataModalDetalle.created_at)}
                          </p>
                          <p>
                              <strong>Valor: </strong>{" "}
                              {formatNumber(dataModalDetalle.monto_principal)}
                          </p>
                          <p>
                              <strong>Seguro: </strong>{" "}
                              {formatNumber(dataModalDetalle.seguro)}
                          </p>
                          <p>
                              <strong>Saldo: </strong>{" "}
                              {formatNumber(dataModalDetalle.saldo_pendiente)}
                          </p>
                          <p>
                              <strong>Valor Cuota: </strong>{" "}
                              {formatNumber(dataModalDetalle.valor_cuota)}
                          </p>
                          <p>
                              <strong>Cuotas Pactadas: </strong>
                              {dataModalDetalle.numero_cuotas}
                          </p>
                          <p>
                              <strong>Forma de Pago: </strong>{" "}
                              {dataModalDetalle.forma_pago?.nombre}
                          </p>
                          <p>
                              <strong>Utilidad: </strong>{" "}
                              {dataModalDetalle.interes_porcentaje} %
                          </p>
                          <p>
                              <strong>Calificación: </strong>{" "}
                              {dataModalDetalle.cliente?.calificacion}
                          </p>
                          <p>
                              <strong>Dirección: </strong>{" "}
                              {dataModalDetalle.cliente?.direccion}
                          </p>
                          <p>
                              <strong>Teléfono: </strong>{" "}
                              {dataModalDetalle.cliente?.celular_1}
                          </p>
                          <p>
                              <strong>Documento: </strong>{" "}
                              {dataModalDetalle.cliente?.documento_identificacion}
                          </p>
                          <p>
                              <strong>Producto: </strong>
                              {dataModalDetalle.producto}
                          </p>
                          <p>
                              <strong>Descripción: </strong>{" "}
                              {dataModalDetalle.descripcion}
                          </p>
                      </>
                  ) : null,
          },
      ];

      // La pestaña "Cronograma" va primera en el orden, pero solo se agrega
      // (se renderiza) cuando dataModalDetalleCuotas trae cuotas.
      if (mostrarCronograma) {
        items.unshift({
          key: "0",
          label: "Cronograma",
          children: (
            <ModalCronograma
              dataModalDetalle={dataModalDetalle}
              dataModalDetalleAbonos={dataModalDetalleAbonos}
              dataModalDetalleCuotas={dataModalDetalleCuotas}
            />
          ),
        });
      }

    return (
        <ModalBottom>
          <ModalHeader icon="" noclose closeModalDetalle={closeModalDetalle}>
            {" "}
            {dataModalDetalle !== ""
                ? dataModalDetalle.cliente.nombre_completo
                : ""}{" "}
          </ModalHeader>
          <ModalContent>
              <Tabs
                  // La key incluye "show" y el id del crédito para forzar un
                  // remount de Tabs cada vez que el modal se abre (incluso
                  // para el mismo crédito) o cuando cambia de crédito. Así
                  // "defaultActiveKey" se vuelve a aplicar en cada apertura y
                  // no queda pegada la última pestaña que se haya usado la
                  // vez anterior (p.ej. "Pago").
                  key={`${show}-${dataModalDetalle !== "" ? dataModalDetalle?.id : "sin-credito"}-${mostrarCronograma}`}
                  defaultActiveKey={mostrarCronograma ? "0" : "1"}
                  onChange={callback}
                  className="ow-tabs"
                  items={items}
              />
          </ModalContent>
        </ModalBottom>
    );
  };

  // Render
  return (
      <div {...props}>
        {type === "centered"
            ? modalCentered()
            : type === "bottom"
                ? modalBottom()
                : "No Modal rendered"}
      </div>
  );
};
const ModalCredito = styled(ModalCredito_base)`
  ${styles}
`;
export default ModalCredito;
